<template>
	<div v-if="laneClosureRequest" :class="{'go-back-container-wrapper':true}" class="mobile-header-menu" id="lane-closure-request-quick-nav-mobile">
		<transition name="slide-up" tag="div">
			<div class="contact-slide-panel" id="contact-slide-panel" v-show="contactsPanel">
				<div class="top-controls">
					<span @click="contactsPanel = false">
						<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
					</span>
				</div>
				<div class="panels-header">
					<div class="title">
						Contacts
					</div>
				</div>
				<b-col lg="5" class="lcr-summary__right-column" id="contact-slide-panel-content">
					<b-row class="row-lcr-summary pt-2 pb-2 no-gutters">
						<b-col>
							<h1>Requester</h1>
							<div class="request__user__info">
							<div class="lcr-summary__value">
								<div v-if="laneClosureRequest.requester" class="contact">
									<div class="contact__name"><a :href="emailHref(laneClosureRequest.requester.email)">{{laneClosureRequest.requester.firstName}} {{laneClosureRequest.requester.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.requester)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="laneClosureRequest.requester.phone" class="contact__phone">{{laneClosureRequest.requester.phone}}</div>
								</div>
								<div v-for="contact in laneClosureRequest.altRequester" v-bind:key="'c'+contact.userId" class="contact">
									<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(contact)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
								</div>
							</div>
							</div>

							<template v-if="laneClosureRequest.owner">
							<h1>Approver</h1>
							<div class="request__user__info">
							<div class="lcr-summary__value">
								<div class="contact">
									<div class="contact__name"><a :href="emailHref(laneClosureRequest.owner.email)">{{laneClosureRequest.owner.firstName}} {{laneClosureRequest.owner.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.owner)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="laneClosureRequest.owner.phone" class="contact__phone">{{laneClosureRequest.owner.phone}}</div>
								</div>
							</div>
							</div>
							</template>
							<template v-if="laneClosureRequest.closureReporter">
							<h1>Closure Reporter</h1>
							<div class="request__user__info">
							<div class="lcr-summary__value">
								<div class="contact">
									<div class="contact__name"><a :href="emailHref(laneClosureRequest.closureReporter.email)">{{laneClosureRequest.closureReporter.firstName}} {{laneClosureRequest.closureReporter.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.closureReporter)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="laneClosureRequest.closureReporter.phone" class="contact__phone">{{laneClosureRequest.closureReporter.phone}}</div>
								</div>
								<div v-for="contact in laneClosureRequest.altClosureReporter" v-bind:key="'c'+contact.userId" class="contact">
									<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(contact)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
								</div>
							</div>
							</div>
							</template>

							<template v-if="laneClosureRequest.restrictionReporter">
							<h1>Restrictions Reporter</h1>
							<div class="request__user__info">
							<div class="lcr-summary__value">
								<div class="contact">
									<div class="contact__name"><a :href="emailHref(laneClosureRequest.restrictionReporter.email)">{{laneClosureRequest.restrictionReporter.firstName}} {{laneClosureRequest.restrictionReporter.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.restrictionReporter)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="laneClosureRequest.restrictionReporter.phone" class="contact__phone">{{laneClosureRequest.restrictionReporter.phone}}</div>
								</div>
								<div v-for="contact in laneClosureRequest.altRestrictionReporter" v-bind:key="'c'+contact.userId" class="contact">
									<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(contact)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
								</div>
							</div>
							</div>
							</template>

							<template v-if="canChangeStatus() || laneClosureRequest.contact.length > 0">
							<h1>Additional Contacts</h1>
							<b-form-group id="ig-additional-contacts" description="">
								<div v-if="laneClosureRequest.contact.length > 0" class="contact-container" id="contact-container">
									<b-form-row v-for=" (contact, index) in laneClosureRequest.contact" class="request__user__info" v-bind:key="'ccr'+contact.userId+'_'+index">
										<b-col cols="8">
											<div class="contact__name">{{contact.firstName}} {{contact.lastName}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(contact)">
												<div class="contact__organization" :key="i">{{org}}</div>
											</template>
											<div class="contact__phone">{{contact.phone}}</div>
										</b-col>
										<b-col cols="4" class="text-right " v-show="canChangeStatus()">
											<b-button variant="text" type="button" class="btn-sm text-secondary" @click="onRemoveContact(index)"><font-awesome-icon icon="minus-circle" /></b-button>
										</b-col>
									</b-form-row>
								</div>
								<div v-show="canChangeStatus()" id="contact-slide-panel__autocomplete-wrapper">
									<autocomplete data-position="above" :get-result-value="getContactResult" :search="onContactSearch" @submit="onContactSelect" @keydown="onContactKeydown" placeholder="Start typing to add contacts" aria-label="Start typing to add contacts" ref="searchContact" auto-select>
										<template v-slot:result=" {result, props } ">
											<li v-bind="props" class="autocomplete-result alternate-contact-result">
												<div class="autocomplete__name">{{result.firstName}} {{result.lastName}}</div>
												<!-- <div v-if="result.organizationName" class="autocomplete__organization">{{result.organizationName}}</div> -->
												<template v-for="(org, i) in getOrganizationTreeList(result)">
													<div v-if="org" :key="i" class="autocomplete__organization">{{org}}</div>
												</template>
												<div v-if="result.phone" class="autocomplete__phone">{{result.phone}}</div>
											</li>
										</template>
									</autocomplete>
								</div>
							</b-form-group>
							</template>
						</b-col>
					</b-row>
				</b-col>
			</div>
			</transition>
			<transition name="slide-down" tag="div">
			<div class="updates-slide-panel" v-show="updatesPanel">
				<div>
					<div v-if="auditBatches.length" lg="5" class="lcr-summary__right-column lcr-summary__right-column-mobile laneclosure-view-container">
						<template>
							<lane-closure-updates-listing v-for="(log, i) in auditBatches"
							:batchDetail="{user: log.userName, notes: log.batchNotes, time: Format.toLocalDateTime(log.batchDate, 'MM/DD/YYYY HH:mm:ss'), auditTypeId: log.auditTypeId,
							organizationName: log.organizationName, organizationType: log.organizationType}"
							:logs="log.auditLog" :lcr="laneClosureRequest" :key="'log-'+i+'-'+renderCounter" />
						</template>
						<div class="text-center" v-if="showViewAllUpdates">
							<b-button type="button" variant="light-blue" @click.stop="onViewUpdates">View All <b-spinner small label="Loading..." class="ml-2" v-if="loadingUpdates"></b-spinner></b-button>
						</div>
					</div>
					<div v-else lg="5" class="lcr-summary__right-column lcr-summary__right-column-mobile laneclosure-view-container">
						<template>
							<div style="margin:auto; padding-top:30px; text-align:center;">
								<b-spinner small label="Loading..." class="ml-2" v-if="loadingUpdates"></b-spinner>
								<strong v-if="loadedUpdates">No changes have been made to this request.</strong>
							</div>
						</template>
					</div>
				</div>
			</div>
		</transition>
			<transition name="slide-down" tag="div">

			<div class="communications-slide-panel" v-show="communicationsPanel">
				<lane-closure-request-chat-mobile :busy="sendingMessage" v-if="selected != 'contraventions'" v-model="laneClosureRequest.message" sourceTable="lcr_message" :laneClosureRequestId="laneClosureRequest.id" ref="newMessage" v-on:message:newMessage="sendNewMessage"></lane-closure-request-chat-mobile>

				<template v-if="contravention">
					<message-chat-mobile :busy="sendingMessage" v-model="contravention.message" :laneClosureRequestId="laneClosureRequest.id" :sourceId="contravention.id" sourceTable="contravention_message" v-bind:key="'edit-contravention-message'+contravention.id" v-on:message:newMessage="sendNewContraventionMessage"></message-chat-mobile>
				</template>
			</div>
		</transition>
		<b-modal centered v-model="showRemoveContactModal" type="info" @ok="onConfirmRemoveContact" ok-title="Yes, Remove Contact" cancel-title="No">
			<template v-slot:modal-title>Confirm Removal</template>
			<p>Do you want to remove this contact?</p>
		</b-modal>
		<b-modal centered id="message__modal__mobile" size="xl" ref="messages__modal" hide-footer :title="getModalTitle">
			<div class="d-block">
				<b-col lg="5" class="lcr-summary__right-column">
					<h2>Messages</h2>

					<lane-closure-request-chat-mobile :busy="sendingMessage" v-if="selected != 'contraventions'" v-model="laneClosureRequest.message" sourceTable="lcr_message" :laneClosureRequestId="laneClosureRequest.id" ref="newMessage" v-on:message:newMessage="sendNewMessage"></lane-closure-request-chat-mobile>

					<template v-if="contravention">
					<message-chat-mobile :busy="sendingMessage" v-model="contravention.message" :laneClosureRequestId="laneClosureRequest.id" :sourceId="contravention.id" sourceTable="contravention_message" v-bind:key="'edit-contravention-message'+contravention.id" v-on:message:newMessage="sendNewContraventionMessage"></message-chat-mobile>
				</template>
				</b-col>
			</div>
			<b-button class="mt-3" variant="primary" @click="$refs['messages__modal'].hide()">Close</b-button>
		</b-modal>


		<b-modal centered id="contacts__modal__mobile" size="xl" ref="contacts__modal" hide-footer title="CONTACTS">
			<div class="d-block">
				<b-col lg="5" class="lcr-summary__right-column">
					<b-row class="row-lcr-summary pt-2 pb-2 no-gutters">
						<b-col>
							<div class="lcr-summary__label">Requester</div>
							<div class="lcr-summary__value">
								<div v-if="laneClosureRequest.requester" class="contact">
									<div class="contact__name"><a :href="emailHref(laneClosureRequest.requester.email)">{{laneClosureRequest.requester.firstName}} {{laneClosureRequest.requester.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.requester)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="laneClosureRequest.requester.phone" class="contact__phone">{{laneClosureRequest.requester.phone}}</div>
								</div>
								<div v-for="contact in laneClosureRequest.altRequester" v-bind:key="'c'+contact.userId" class="contact">
									<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(contact)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
								</div>
							</div>
						</b-col>
						<b-col v-if="laneClosureRequest.owner">
							<div class="lcr-summary__label">Approver</div>
							<div class="lcr-summary__value">
								<div class="contact">
									<div class="contact__name"><a :href="emailHref(laneClosureRequest.owner.email)">{{laneClosureRequest.owner.firstName}} {{laneClosureRequest.owner.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.owner)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="laneClosureRequest.owner.phone" class="contact__phone">{{laneClosureRequest.owner.phone}}</div>
								</div>
							</div>
						</b-col>
					</b-row>
					<b-row class="row-lcr-summary pb-2 pt-2 no-gutters">
						<b-col class="" v-if="laneClosureRequest.closureReporter">
							<div class="lcr-summary__label">Closure Reporter</div>
							<div class="lcr-summary__value">
								<div class="contact">
									<div class="contact__name"><a :href="emailHref(laneClosureRequest.closureReporter.email)">{{laneClosureRequest.closureReporter.firstName}} {{laneClosureRequest.closureReporter.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.closureReporter)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="laneClosureRequest.closureReporter.phone" class="contact__phone">{{laneClosureRequest.closureReporter.phone}}</div>
								</div>
								<div v-for="contact in laneClosureRequest.altClosureReporter" v-bind:key="'c'+contact.userId" class="contact">
									<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(contact)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
								</div>
							</div>
						</b-col>
						<b-col v-if="laneClosureRequest.restrictionReporter">
							<div class="lcr-summary__label">Restrictions Reporter</div>
							<div class="lcr-summary__value">
								<div class="contact">
									<div class="contact__name"><a :href="emailHref(laneClosureRequest.restrictionReporter.email)">{{laneClosureRequest.restrictionReporter.firstName}} {{laneClosureRequest.restrictionReporter.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.restrictionReporter)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="laneClosureRequest.restrictionReporter.phone" class="contact__phone">{{laneClosureRequest.restrictionReporter.phone}}</div>
								</div>
								<div v-for="contact in laneClosureRequest.altRestrictionReporter" v-bind:key="'c'+contact.userId" class="contact">
									<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
									<template v-for="(org, i) in getOrganizationTreeList(contact)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
								</div>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col class="pt-2">
							<div class="lcr-summary__label" v-show="canChangeStatus() || laneClosureRequest.contact.length > 0">Additional Contacts</div>
							<b-form-group id="ig-additional-contacts" description="">
								<div v-if="laneClosureRequest.contact.length > 0" class="contact-container">
									<b-form-row v-for=" (contact, index) in laneClosureRequest.contact" class="contact" v-bind:key="'ccr'+contact.userId+'_'+index">
										<b-col cols="8">
											<div class="contact__name">{{contact.firstName}} {{contact.lastName}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(contact)">
												<div class="contact__organization" :key="i">{{org}}</div>
											</template>
											<div class="contact__phone">{{contact.phone}}</div>
										</b-col>
										<b-col cols="4" class="text-right " v-show="canChangeStatus()">
											<b-button variant="text" type="button" class="btn-sm text-secondary" @click="onRemoveContact(index)"><font-awesome-icon icon="minus-circle" /></b-button>
										</b-col>
									</b-form-row>
								</div>
								<div v-show="canChangeStatus()">
									<autocomplete data-position="above" :get-result-value="getContactResult" :search="onContactSearch" @submit="onContactSelect" @keydown="onContactKeydown" placeholder="Start typing to add contacts" aria-label="Start typing to add contacts" ref="searchContact" auto-select>
										<template v-slot:result=" {result, props } ">
											<li v-bind="props" class="autocomplete-result alternate-contact-result">
												<div class="autocomplete__name">{{result.firstName}} {{result.lastName}}</div>
												<!-- <div v-if="result.organizationName" class="autocomplete__organization">{{result.organizationName}}</div> -->
												<template v-for="(org, i) in getOrganizationTreeList(result)">
													<div v-if="org" :key="i" class="autocomplete__organization">{{org}}</div>
												</template>
												<div v-if="result.phone" class="autocomplete__phone">{{result.phone}}</div>
											</li>
										</template>
									</autocomplete>
								</div>
							</b-form-group>
						</b-col>
					</b-row>
				</b-col>
			</div>
			<b-button class="mt-3" variant="primary" @click="$refs['contacts__modal'].hide()">Close</b-button>
		</b-modal>
		<b-modal centered id="update__modal__mobile" ref="updates__modal" hide-footer title="UPDATES">
			<b-col v-if="auditBatches.length" lg="5" class="lcr-summary__right-column lcr-summary__right-column-mobile laneclosure-view-container">
				<template>
					<lane-closure-updates-listing v-for="(log, i) in auditBatches"
					:batchDetail="{user: log.userName, notes: log.batchNotes, time: Format.toLocalDateTime(log.batchDate, 'MM/DD/YYYY HH:mm:ss'), auditTypeId: log.auditTypeId,
					organizationName: log.organizationName, organizationType: log.organizationType}"
					:logs="log.auditLog" :lcr="laneClosureRequest" :key="'log-'+i+'-'+renderCounter" />
				</template>


				<div class="text-center" v-if="auditBatchCount > auditBatches.length">
					<b-button type="button" variant="light-blue" @click="onViewUpdates">View All Updates <b-spinner small label="Loading..." class="ml-2" v-if="loadingUpdates"></b-spinner></b-button>
				</div>
<!-- 				<div class="text-center" v-if="auditBatchCount == auditBatches.length && auditBatchCount > 3">
					<b-button type="button" variant="light-blue" @click="onViewRecent">View Latest 3 <b-spinner small label="Loading..." class="ml-2" v-if="loadingUpdates"></b-spinner></b-button>
				</div> -->
			</b-col>
			<b-col v-else>
				No updates available
			</b-col>
			<b-button class="mt-3" variant="primary" @click="$refs['updates__modal'].hide()">Close</b-button>
		</b-modal>
		<b-container class="go-back">
			<b-nav small  class="lcr-quick-nav">
				<b-nav-item ref="navLcrBackToList" :class="{'no-border':selected == 'view', 'nav-item-back-to-list':true}" :to="backToList"><span>
					<b-img src="/img/nav/icon-back.svg" alt="menu" />
					List</span></b-nav-item>
				<li v-if="false" class="nav-item no-border nav-item-back-to-list"><a @click="goBack" class="nav-link" target="_self"><span><b-img src="/img/nav/icon-back.svg" alt="menu" /> List</span></a></li>


				<b-nav-item v-if="this.value" @click="toggleCommunicationPanel() " :class="{'nav-item-messages':true,'no-border':true, 'side-filter-active':communicationsPanel}">
					<span>
						<b-img src="/img/lcr-quick-nav/blank.png"></b-img>
						<span class="menu-text">Communication</span>
					</span>
				</b-nav-item>
				<b-nav-item v-if="this.value" @click="toggleUpdatePanel();" :class="{'nav-item-updates':true,'no-border':true, 'side-filter-active':updatesPanel}">
					<span>
						<b-img src="/img/lcr-quick-nav/blank.png"></b-img>
						<span class="menu-text">Activity</span>
					</span>
				</b-nav-item>

				<b-nav-item @click="toggleMenu" class="nav-item-menu no-border">
					<span>
						<b-img src="/img/nav/icon-menu.svg" alt="menu" />
						<span class="menu-text">Menu</span>
					</span>
				</b-nav-item>


				<b-nav-item v-if="false" ref="navLcrEdit" class="nav-item-more-action no-border" @click="toggleActionDropdown">
					<span>
						<b-img src="/img/lcr-quick-nav/blank.png"></b-img>
						<b-dropdown ref="toggle__dropdown" id="lc__actions__menu">
							<template #button-content>
								<span class="menu-text">Actions</span>
							</template>
							<b-dropdown-item v-show="canReportContravention()" @click="onReportContravention">Report Violation</b-dropdown-item>
							<b-dropdown-item v-show="canReportClosure()" @click="onReportLaneClosure">Close / Re-open Lanes</b-dropdown-item>
							<b-dropdown-item v-show="canReportRestriction()" @click="onReportRestriction">Place / Remove Restrictions</b-dropdown-item>
							<b-dropdown-item v-show="canCompleteRequest()" @click="showCompleteRequestModal">Mark Request As Completed</b-dropdown-item>
							<b-dropdown-item v-show="canCancelRequest()" @click="showCancelRequestModal">
								Cancel Request <b-spinner small label="Saving..." class="ml-2" v-if="cancelSaving" />
							</b-dropdown-item>
						</b-dropdown>
					</span>
				</b-nav-item>
			</b-nav>
		</b-container>
	</div>
</template>


<script>
import Vue from 'vue';
import Format from '../utility/Format';
import ErrorHandler from '../utility/ErrorHandler';
import LaneClosureRequestMessage from '../models/LaneClosureRequestMessage';
import LaneClosureRequestChatMobile from '../components/LaneClosureRequestChatMobile';
import MessageChatMobile from '../components/MessageChatMobile';
import LaneClosureUpdatesListing from '../components/LaneClosureUpdatesListing.vue';
import Autocomplete from '@trevoreyre/autocomplete-vue'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';


export default {
	props: ['value', 'selected', 'contravention'],
	components: {
		LaneClosureRequestChatMobile,
		MessageChatMobile,
		LaneClosureUpdatesListing,
		Autocomplete,
	},
	data() {
		return {
			loadingUpdates: false,
			loadedUpdates: false,
			showViewAllUpdates: true,
			errorDetails: {
				error: {
					details:null
				}
			},
			contactsPanel: false,
			updatesPanel: false,
			communicationsPanel: false,
			sendingMessage:false,
			renderCounter: 0,
			auditBatches: [],
			auditBatchCount: '',
			modalRequiredFieldList: [],
			showToggleActionDropdown: false,
			showCancelModal: false,
			showCompletedModal: false,
			removeContactIndex:null,
			showRemoveContactModal: false,
			cancelSaving: false,
			showLoadErrorModal: false,
			isAnimating: false,
			viewedCommunication:false,
		}
	},
	computed: {
		getModalTitle() {
			let title = "COMMUNICATION";
			if (this.selected =="contraventions") {
				if (this.contravention) {
					title = "COMMUNICATION - VIOLATION #" + this.contravention.id;
				}
			}
			return title;
		},

		backToList() {
			// let lastPage = this.$routerStore.getters['previousRoute'];
			// if (lastPage.name == this.$router.name	) {
			// 	lastPage =  this.$routerStore.getters['getLastListPage'];
			// 	if (lastPage == null) {
			// 		return "/lane-closure-request-list";
			// 	}
			// }

			let lastPage = this.$routerStore.getters['getLastListPageOrViewRequest'];
			if (lastPage == null) {
				return "/lane-closure-request-list";
			} else {
				if (lastPage.name == this.$router.name	) {
					lastPage =  this.$routerStore.getters['getLastListPage'];
					if (lastPage == null) {
						return "/lane-closure-request-list";
					}
				} else {
					lastPage =  this.$routerStore.getters['getLastListPage'];
					if (lastPage == null) {
						return "/lane-closure-request-list";
					}
				}
			}
			return lastPage.path;
		},
		laneClosureRequest() {
			return this.value;
		},
		getViewLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/view";
			}
			return null;
		},
		getAttachmentsCount() {
			if (this.value) {
				if (this.value.attachment.length > 0) {
					return " (" + this.value.attachment.length + ")";
				}
			}
			return null
		},
		getEditRequestLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/edit";
			}
			return null;
		},
		getActivityLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/activity";
			}
			return null;
		},
		getContraventionsLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/contraventions";
			}
			return null;
		},
		getAttachmentsLink() {
			if (this.value) {
				return "/lane-closure-request/"+this.value.id+"/attachments";
			}
			return null;
		},
		getDuplicateLink() {
			return "/new-lane-closure-request";
		},

		canGotoActivity() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
				return true;
			}
			return false;
		},
	},
	watch: {
		contactsPanel(newValue, oldValue) {
			clearAllBodyScrollLocks();
			if (this.updatesPanel == true || this.communicationsPanel == true) {
				this.fixMainDiv('shown');
			} else {
				if(newValue) {
					this.fixMainDiv('shown');
					disableBodyScroll(document.querySelector('.contact-slide-panel'));
				} else {
					this.fixMainDiv('hidden');
				}
			}
		},
		/*
		updatesPanel(newValue, oldValue) {
			if (this.contactsPanel == true || this.communicationsPanel == true) {
				this.fixMainDiv('shown');
			} else {
				if(newValue) {
					this.fixMainDiv('shown');
				} else {
					this.fixMainDiv('hidden');
				}
			}
		},
		communicationsPanel(newValue, oldValue) {
			if(newValue) {
				this.fixMainDiv('shown');
			} else {
				this.fixMainDiv('hidden');
			}
		},
		*/
	},
	created() {
		Vue.prototype.$bus.$on('keyboard:willShow', this.keyboardWillShow);
		Vue.prototype.$bus.$on('keyboard:didShow', this.keyboardDidShow);
		Vue.prototype.$bus.$on('keyboard:willHide', this.keyboardWillHide);
		Vue.prototype.$bus.$on('keyboard:didHide', this.keyboardDidHide);
		Vue.prototype.$bus.$on('slideUpMenu:viewLcr:click', this.hideAllSlideDown);
	},
	destroyed() {
	    Vue.prototype.$bus.$off('keyboard:willShow', this.keyboardWillShow);
	    Vue.prototype.$bus.$off('keyboard:didShow', this.keyboardDidShow);
	    Vue.prototype.$bus.$off('keyboard:willHide', this.keyboardWillHide);
	    Vue.prototype.$bus.$off('keyboard:didHide', this.keyboardDidHide);
		Vue.prototype.$bus.$off('slideUpMenu:viewLcr:click', this.hideAllSlideDown);

		if (document.getElementById("lane-closure-request-quick-nav-mobile")) {
			document.getElementById("lane-closure-request-quick-nav-mobile").removeEventListener('touchstart', this.onTouchStart);
			document.getElementById("lane-closure-request-quick-nav-mobile").removeEventListener('touchend', this.onTouchEnd);
		}
	},
	mounted() {

		let that = this;


		setTimeout(function() {
			if (document.getElementById("lane-closure-request-quick-nav-mobile")) {
				document.getElementById("lane-closure-request-quick-nav-mobile").addEventListener('touchstart', that.onTouchStart, false);
				document.getElementById("lane-closure-request-quick-nav-mobile").addEventListener('touchend', that.onTouchEnd, false);
			}

			if (typeof document.getElementsByClassName('lcr-quick-nav') != "undefined") {
				if (typeof document.getElementsByClassName('lcr-quick-nav')[0] != "undefined") {
					document.getElementsByClassName('lcr-quick-nav')[0].scrollLeft = 0;
					var menus = document.getElementsByClassName('nav-item');
					for (var i = 0; i < menus.length; i++) {
						if (menus[i].querySelector('.nav-link')) {
							if (menus[i].querySelector('.nav-link').classList.contains('router-link-active')) {
								document.getElementsByClassName('go-back')[0].scrollLeft = menus[i].offsetLeft - 130;
							}
						}
					}
				}
			}
		}, 500)



		document.getElementsByClassName("navbar")[0].display = 'none';
		this.$root.$on('bv::dropdown::hide', bvEvent => {
			if(bvEvent.componentId == 'lc__actions__menu') {
				this.showToggleActionDropdown = false;
			}
		});
		this.$root.$on('bv::dropdown::show', bvEvent => {
			if(bvEvent.componentId == 'lc__actions__menu') {
				this.showToggleActionDropdown = true;
			}
		});

		Vue.prototype.$bus.$on("request:showContacts", this.showContactsModal);

	},
	beforeRouteEnter(to, from, next) {
	},
	// Sets the display value on creation
	methods: {
		keyboardWillShow() {
			var height = this.$store.getters['keyboardHeight'];
			if (height == null) {
				height = 300;
			}
			var obj = document.getElementById("contact-slide-panel__autocomplete-wrapper");
			if (obj) {
				obj.style.bottom = height + "px";
			}
		},
		keyboardWillHide() {
			var height = this.$store.getters['keyboardHeight'];
			var obj = document.getElementById("contact-slide-panel__autocomplete-wrapper");
			if (obj) {
				obj.style.bottom = "0px";
				obj.style.bottom = height + "px";
			}

		},

		keyboardDidShow() {
			var height = this.$store.getters['keyboardHeight'];
			if (height == null) {
				height = 300;
			}
			height = height + 50; // height of the text area field...
			// document.getElementById("messages-mobile").style.bottom = height + "px";
		},
		keyboardDidHide() {
			var obj = document.getElementById("contact-slide-panel__autocomplete-wrapper");
			if (obj) {
				obj.style.bottom = "0px";
				// obj.style.bottom = height + "px";
			}
		},

		onTouchStart(event) {
			event.stopPropagation();
		    this.touchstartX = event.changedTouches[0].screenX;
		    this.touchstartY = event.changedTouches[0].screenY;
			if (event.changedTouches[0].screenX < 0) {
				this.touchstartX = event.changedTouches[0].pageX;
			}
			if (event.changedTouches[0].screenY < 0) {
				this.touchstartY = event.changedTouches[0].pageY;
			}
		},
		onTouchEnd(event) {
			event.stopPropagation();
		    this.touchendX = event.changedTouches[0].screenX;
		    this.touchendY = event.changedTouches[0].screenY;
			if (event.changedTouches[0].screenX < 0) {
				this.touchendX = event.changedTouches[0].pageX;
			}
			if (event.changedTouches[0].screenY < 0) {
				this.touchendY = event.changedTouches[0].pageY;
			}
		    this.handleGesture();
		},


		handleGesture() {
		    if (this.touchendX < this.touchstartX) {
		        if (this.$root.$isEdgeRight) {
		        	// swiped left.
			    }
		    }

		    // swipe right
		    if (this.touchendX > this.touchstartX) {
		        if (this.$root.$isEdgeLeft
		        || (this.touchstartX > -710 && this.touchstartX < -662 && this.touchendX > -622)
		        || (this.touchstartX >= 0 && this.touchstartX < 48 && this.touchendX >= 48)
		        ) {
			        this.contactsPanel= false;
			        this.updatesPanel = false;
			        return;
			    }
		    }
		    // swipe down
	        if (this.touchendY > this.touchstartY && this.touchstartY < 80 ) {
    	        this.contactsPanel= false;
    	        this.updatesPanel = false;
    	        return;
	        }


		},
		toggleCommunicationPanel() {

			if (!this.isAnimating) {
				this.isAnimating = true;
				clearAllBodyScrollLocks();
				if (this.communicationsPanel == false || this.updatesPanel == true) {
					this.fixMainDiv('shown');
				} else {
					if (this.communicationsPanel == true) {
						this.fixMainDiv('hidden');
					}
				}



				this.updatesPanel = false;
				this.communicationsPanel = !this.communicationsPanel;
				Vue.prototype.$bus.$emit('slideUpMenu:hideAll');

				// scroll down to bottom of chat if this is the first time viewing it for this request..
				let that = this;
				setTimeout(function() {
					if (!that.viewedCommunication) {
						that.viewedCommunication = true;
						that.$smoothScroll({
						  scrollTo: document.getElementById("message-box-bottom"),
						  container:document.getElementById("messages-mobile"),
						  duration: 0,
						  offset: 1000
						});
					}
				}, 10)

				// disable body scrolling.
				setTimeout(function() {
					that.isAnimating = false;
					if (that.communicationsPanel) {
						disableBodyScroll(document.querySelector('#messages-mobile'));
					}
				}, 500)
			}
		},
		toggleUpdatePanel() {
			if (!this.isAnimating) {
				this.isAnimating = true;
				clearAllBodyScrollLocks();
				if (this.communicationsPanel == true || this.updatesPanel == false) {
					this.fixMainDiv('shown');
				} else {
					if (this.updatesPanel == true) {
						this.fixMainDiv('hidden');
					}
				}

				this.communicationsPanel = false;
				this.updatesPanel = !this.updatesPanel;
				Vue.prototype.$bus.$emit('slideUpMenu:hideAll');
				let that = this;
				setTimeout(function() {
					that.isAnimating = false;
					if (that.updatesPanel == true) {
						disableBodyScroll(document.querySelector('.updates-slide-panel'));
						console.log(that.loadedUpdates);
						if (!that.loadedUpdates) {
							that.GetLatestUpdates(that.value.id);
						}
					}
				}, 500)
			}
		},

		fixMainDiv(condition) {
			// console.log(condition);
			if(condition == 'shown') {
				document.getElementById("main").classList.add('remove-bottom-position');
			} else {
				document.getElementById("main").classList.remove('remove-bottom-position');
			}
		},
		showContactsModal() {
			if (!this.isAnimating) {
				this.isAnimating = true;
				this.contactsPanel = !this.contactsPanel;
				let that = this;
				setTimeout(function() {
					that.isAnimating = false;
				}, 500);
			}

			// if (this.$refs['contacts__modal']) {
			// 	this.$refs['contacts__modal'].show();
			// }
		},

		goBack(evt) {
			// this.backMixin_handleBack();
			history.go(-1);
		},

		toggleMenu() {
			Vue.prototype.$bus.$emit('menu:toggle', null);
		},
		sendNewContraventionMessage(obj) {
			// console.log("sendNewContraventionMessage");
			// console.log(obj);
			if (obj.message != null && obj.message != "") {
				this.sendingMessage = true;
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/contravention/${this.contravention.id}/new-message?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: obj
				}).then(resp => {
					this.contravention.message = [];
					let x = 0;
					for (x = 0; x < resp.data.length; x++) {
						this.contravention.message.push(new LaneClosureRequestMessage(resp.data[x]));
					}
					this.sendingMessage = false;

					this.PostNewContraventionMessageSuccess();
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.laneClosureRequest.SetErrors(error.response.data);
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				}).finally(() => {
					this.sendingMessage = false;
				});


			}
		},
		PostNewContraventionMessageSuccess() {
			this.$nextTick(() => {
				this.$bus.$emit('message:success', null);
			});
		},


		sendNewMessage(obj) {
			if (obj.message != null && obj.message != "") {
				this.sendingMessage = true;
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/new-message?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: obj
				}).then(resp => {
					this.laneClosureRequest.message = [];
					let x = 0;
					for (x = 0; x < resp.data.length; x++) {
						this.laneClosureRequest.message.push(new LaneClosureRequestMessage(resp.data[x]));
					}
					this.PostNewMessageSuccess();
				}).catch(error => {
					/*
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.laneClosureRequest.SetErrors(error.response.data);
						this.errorDetails = error.response.data;
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
					*/
				}).finally(() => {

					this.sendingMessage = false;

				});
			}

			// // "{id}/contravention/{contraventionId}/new-message
			// if (obj.message != null && obj.message != "" ) {
			// 	Vue.prototype.$http({
			// 		method: 'post',
			// 		url: `${this.$store.state.apiUrl}/message/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
			// 		data: obj
			// 		}).then(resp => {
			// 			console.log(this.laneClosureRequest);
			// 			if (""+this.laneClosureRequest.id == ""+obj.sourceId) {
			// 				this.$nextTick(() => {
			// 					this.laneClosureRequest.message.unshift(new LaneClosureRequestMessage(resp.data));
			// 				});
			// 			}

			// 		this.PostNewMessageSuccess();
			// 	}).catch(error => {
			// 		/*
			// 		if (!ErrorHandler.HasLoginErrorCode(error)) {
			// 			this.showErrors(error.response.data.fields);
			// 		}
			// 		*/
			// 	}).finally(() => {
			// 	});
			// }
		},
		PostNewMessageSuccess() {
			this.$nextTick(() => {
				this.$bus.$emit('message:success', null);
				/*
				var obj = document.getElementById("message-box-bottom");
				var obj2 = document.getElementById("messages-mobile");
				if (obj2) {
					obj.scrollTo({ top: obj.scrollHeight, behavior: 'smooth' })
				} else {
					if (obj) {
						console.log("message-box-bottom");
						obj.scrollIntoView({block: "end", inline: "nearest",behavior: 'smooth'});
					}
					if (obj2) {
						obj2.scrollBy(0,-5);
					}
				}
				//document.getElementById("messages-mobile").scrollBy(0,-5);
				*/
			});
		},


		GetAllUpdates(id) {
			this.loadingUpdates = true;
			return Vue.prototype.$http({
						method: 'get',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${id}/all-updates?r=${Math.round(Math.random() * Math.pow(10, 6))}`
					}).then(response => {
						this.loadingUpdates = false;
						this.auditBatches = response.data.data;
						this.auditBatchCount = response.data.count;
						this.showViewAllUpdates = false;
						this.loadedUpdates = true;
					});
		},


		GetLatestUpdates(id) {
			this.loadingUpdates = true;
			return Vue.prototype.$http({
						method: 'get',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${id}/latest-updates?r=${Math.round(Math.random() * Math.pow(10, 6))}`
					}).then(response => {
						this.loadingUpdates = false;
						this.auditBatches = response.data.data;
						this.auditBatchCount = response.data.count;
						// this.updatesPanel = true;
						this.showViewAllUpdates = true;
						this.loadedUpdates = true;
					});
		},
		onViewUpdates() {
			this.GetAllUpdates(this.laneClosureRequest.id);
		},
		onViewRecent() {
			this.GetLatestUpdates(this.laneClosureRequest.id).then((response) => {
				this.$nextTick(() => {
					// var main = document.getElementById("main");
					// var jumpTo = document.getElementById("updatesList");
					// main.scrollTo(0, jumpTo.offsetTop);
				});
			});
		},
		onRemoveContact(index) {
			this.showRemoveContactModal = true;
			this.removeContactIndex = index;
		},
		onConfirmRemoveContact() {
			// attach the new contact to the LCR
			Vue.prototype.$http({
				method: 'post',
				url: Format.getApiUrl("/lane-closure-request/" + this.laneClosureRequest.id + "/remove-contact/" + this.laneClosureRequest.contact[this.removeContactIndex].userId)
			}).then(response => {
				this.laneClosureRequest.contact.splice(this.removeContactIndex, 1);
			}).catch(error => {
				if (!ErrorHandler.HasLoginErrorCode(error)) {
					if (error.response && error.response.data) {
						this.loaded = false;
						this.transactionStatus = 'load-error';
						this.errorDetails = error.response.data;
					}
				} else {
					// ErrorHandler.RedirectToLogin();
				}
			});
		},
		onCancelRemoveContact() {
			this.removeContactIndex = null;
			this.showRemoveContactModal = false;
		},

		onCompleteRequest() {
			this.$bus.$emit('markLaneClosureCompleted', this.laneClosureRequest);
		},
		onContactKeydown(event) {
			const {key} = event;
			if (key == "Tab") {
				if (this.$refs.searchContact.value)
				this.onContactSelect(this.$refs.searchContact.value);
			}
		},
		onContactSelect(selected) {
			// add the selected contact to the alternate listing, with a delete button as well.
			let found = false;
			for (var entry in this.laneClosureRequest.contact) {
				if (this.laneClosureRequest.contact[entry].userId == selected.userId) {
					// already in the list.
					found = true;
				}
			}
			if (!found) {
				// attach the new contact to the LCR
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/add-contact/${selected.userId}?r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					this.laneClosureRequest.contact.push(selected);
					this.$refs.searchContact.value = "";
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						if (error.response && error.response.data) {
							this.loaded = false;
							this.transactionStatus = 'load-error';
							this.errorDetails = error.response.data;
						}
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				});
			}
		},

		getContactResult(result) {
			// don't show it in the dropdown.
			return "";
		},
		onContactSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/assignable?q=' + encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		emailHref(value) {
			return "mailto:" + value;
		},
		canChangeStatus() {
			if (this.laneClosureRequest) {
				if (this.$store.getters.userHasRole('internal_admin_requests')) {
					return true;
				}
			}
			return false;
		},
		getOrganizationTreeList(user) {
			if (user.organizationTree) {
				let treeString = user.organizationTree;
				let treeList = treeString.split("|");
				treeList.pop();
				treeList.shift();
				treeList.reverse();
				return treeList;
			} else {
				return new Array(user.organizationName);
			}
		},
		getOrganizationIdTreeList(user) {
			if (user.organizationIdTree) {
				let treeString = user.organizationIdTree;
				let treeList = treeString.split("|");
				treeList.pop();
				treeList.shift();
				treeList.reverse();
				return treeList;
			} else {
				return new Array(user.organizationId);
			}
		},
		toggleActionDropdown() {
			if(typeof this.$refs.toggle__dropdown != 'undefined') {
				this.showToggleActionDropdown = !this.showToggleActionDropdown;
				(this.showToggleActionDropdown) ? this.$refs.toggle__dropdown.show() : this.$refs.toggle__dropdown.hide();
			}
		},
		canReportContravention() {
			if (this.laneClosureRequest) {
				if (this.$store.getters.userHasRole('officer_requests') || this.$store.getters.userHasRole('internal_admin_requests')) {
					return true;
				}
			}
			return false;
		},
		canCancelRequest() {
			if (this.laneClosureRequest) {
				if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userId() == this.laneClosureRequest.requesterId) {
					if (this.laneClosureRequest.recordStatusId.value != 7) {
						return true;
					}
				}
			}
			return false;
		},
		canDuplicateRequest() {
			// if (this.laneClosureRequest) {
			// 	if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			// 		return true;
			// 	}
			// 	if (this.$store.getters.userId() == this.laneClosureRequest.requesterId) {
			// 		return true;
			// 	}
			// 	if (this.$store.getters.userInfo() && this.$store.getters.userInfo().userOrganizations.includes(this.laneClosureRequest.requester.organizationId)) {
			// 		return true;
			// 	}
			// }
			// return false;
			let canReport = false;
			if (this.laneClosureRequest) {
				// if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canOrg = this.$store.getters.userHasPermission('lcr_update_org');
					let canMine = this.$store.getters.userHasPermission('lcr_update_mine');
					let canAll = this.$store.getters.userHasPermission('lcr_update_all');

					if (!canMine && !canAll && !canOrg) {
						return false;
					}

					if (canAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}
				// }
			}
			return canReport;
		},
		canCompleteRequest() {

			let canReport = false;
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canOrg = this.$store.getters.userHasPermission('lcr_update_org');
					let canMine = this.$store.getters.userHasPermission('lcr_update_mine');
					let canAll = this.$store.getters.userHasPermission('lcr_update_all');

					if (!canMine && !canAll && !canOrg) {
						return false;
					}

					if (canAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.closureReporterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
						if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}

					if (!canReport) {
						if (this.laneClosureRequest.altClosureReporter) {
							for (x = 0; x < this.laneClosureRequest.altClosureReporter.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altClosureReporter[x].userId + "") {
									canReport = true;
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altClosureReporter[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}

						}
					}

				}
			}
			return canReport;


		},
		canReportRestriction() {

			let canReport = false;
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canOrg = this.$store.getters.userHasPermission('rr_org');
					let canMine = this.$store.getters.userHasPermission('rr_mine');
					let canAll = this.$store.getters.userHasPermission('rr_all');

					if (!canMine && !canAll && !canOrg) {
						return false;
					}

					if (canAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.restrictionReporterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
						if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}

					if (!canReport) {
						if (this.laneClosureRequest.altRestrictionReporter) {
							for (x = 0; x < this.laneClosureRequest.altRestrictionReporter.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRestrictionReporter[x].userId + "") {
									canReport = true;
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRestrictionReporter[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}

						}
					}

					if (canReport) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].restriction.length > 0) {
								return true;
							}
						}
					}
				}
			}
			return canReport;

		},

		canReportClosure() {
			let canReport = false;
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canOrg = this.$store.getters.userHasPermission('rlc_org');
					let canMine = this.$store.getters.userHasPermission('rlc_mine');
					let canAll = this.$store.getters.userHasPermission('rlc_all');



					if (!canMine && !canAll && !canOrg) {
						return false;
					}

					if (canAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.closureReporterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
						if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}

					if (!canReport) {
						if (this.laneClosureRequest.altClosureReporter) {
							for (x = 0; x < this.laneClosureRequest.altClosureReporter.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altClosureReporter[x].userId + "") {
									canReport = true;
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altClosureReporter[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}

						}
					}

					if (canReport) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].lane) {
								if (this.laneClosureRequest.block[x].lane.length > 0) {
									return true;
								}
							}
							if (this.laneClosureRequest.block[x].bicycle) {
								if (this.laneClosureRequest.block[x].bicycle.length > 0) {
									return true;
								}
							}
							if (this.laneClosureRequest.block[x].sidewalk) {
								if (this.laneClosureRequest.block[x].sidewalk.length > 0) {
									return true;
								}
							}
						}
					}
				}
			}
			return canReport;

		},
		hideAllSlideDown() {
			this.communicationsPanel = false;
			this.updatesPanel = false;
			clearAllBodyScrollLocks();
		},
	}
};
</script>
<style>
.lcr-quick-nav .nav-item-messages .router-link-active img {
	background-image: url('/img/lcr-quick-nav/lc-header-messages-white.png');
}
.lcr-quick-nav .nav-item-messages img {
	background-image: url('/img/nav/icon-messages.svg');
}
.lcr-quick-nav .nav-item-updates .router-link-active img {
	background-image: url('/img/nav/icon-bell-circle.svg');
}
.lcr-quick-nav .nav-item-updates img {
	background-image: url('/img/nav/icon-bell-circle.svg');
}
.lcr-quick-nav .nav-item-more-action .router-link-active img {
	background-image: url('/img/lcr-quick-nav/lc-cogs.png');
}
.lcr-quick-nav .nav-item-more-action img {
	background-image: url('/img/lcr-quick-nav/lc-cogs-white.png');
}
</style>